import React, { FC } from 'react';
import { isEmpty } from 'lodash';
import { useSurveyLoader } from './services/SurveyService';
import { Survey } from './models/Survey';

type SurveyLoaderProps = {
  children: FC<Survey[]>;
  fallbackElement?: React.ReactElement;
};
export const SurveyLoader = ({
  children,
  fallbackElement,
}: SurveyLoaderProps) => {
  const surveys = useSurveyLoader();
  if (surveys === 'loading') {
    return null;
  }
  if (surveys === 'error') {
    console.log('Error fetching surveys');
    return fallbackElement;
  }
  if (isEmpty(surveys)) {
    return fallbackElement;
  }
  return children(surveys);
};
